export function getStatusStr(type){
  let typeStr =  ""
  switch(type){
    case -1:
      typeStr = "全部"
      break
    case 0:
      typeStr = "未完成"
      break
    case 1:
      typeStr = "已完成"
      break
    case 2:
      typeStr = "已取消"
      break
    case 3:
      typeStr = "已撤销"
      break
  }
  return typeStr
}

export const platTypeChoose = [{
    label:"全部",
    value:""
  },{
    label:"AG",
    value:"ag"
  },{
    label:"PP",
    value:"pp"
  },{
    label:"KY",
    value:"ky"
}]
